import React from "react";
import "./loader.css";
import { useSelector } from 'react-redux';
const Loader = () => {
  const loading = useSelector((state) => state.loader.loading);
     if (!loading) return null;
  return (
     <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-40">
      <div className="loader-1"></div>
    </div>
  )
};

export default Loader;
